import tinycolor from 'tinycolor2';

var Theme;
(function (Theme) {
  Theme.getLight = function (primaryColor) {
    return {
      textSubtle: tinycolor('black').setAlpha(0.51).toHslString(),
      textDefault: tinycolor('black').setAlpha(0.74).toHslString(),
      textContrast: 'black',
      textInvalid: '$red9',
      textRed: '$red10'
    };
  };
  Theme.getDark = function (primaryColor) {
    return {
      textSubtle: tinycolor('white').setAlpha(0.51).toHslString(),
      textDefault: tinycolor('white').setAlpha(0.74).toHslString(),
      textContrast: 'white',
      textInvalid: '$red9',
      textRed: '$red10'
    };
  };
})(Theme || (Theme = {}));

export { Theme };
